import { Controller } from "@hotwired/stimulus"

// "Sync in progress" state for a single linked-bank row.
//
// Fires when the user picks Sync from the row's native menu (the hidden sync
// link's click). It sets the SAME data-sync-state attribute the Sync all
// cascade sets, so one bank synced on its own animates exactly like one bank
// inside a full pass: the tile scales and grows its orbit ring, the row lifts
// and sheens, the ⋯ steps aside, and the trailing slot swaps to "Syncing…".
// Every one of those visuals is pure CSS keyed off the attribute — this
// controller sets the attribute and nothing else.
//
// No teardown: the sync redirect replaces the page, which resets the state
// naturally.
export default class extends Controller {
  syncing() {
    this.element.dataset.syncState = "active"
  }
}
